// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__IZtCp","modal":"styles_modal__0Gxoh","title":"styles_title__M0gVb","input":"styles_input__HLPrs","button":"styles_button__o3Eon"};